import { useEffect } from 'react';

const BASE_URL = 'https://digitivehealth.com';

const defaults = {
  title: 'Digitive Health - Healthcare Staffing Solutions',
  description: 'Digitive Health connects qualified nursing, allied health, and non-clinical professionals with healthcare facilities nationwide. Travel staffing, direct hire, and managed services.',
  ogType: 'website',
  ogImage: 'https://static.prod-images.emergentagent.com/jobs/3c79fc15-7acb-4945-a01c-dd7a9cf21362/images/dade111af330bfa8eb26a49bacf6906a245000920e9f0a33f418046594187ed0.png',
};

function setMeta(name, content, attribute = 'name') {
  let el = document.querySelector(`meta[${attribute}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attribute, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function usePageMeta({ title, description, path = '/', ogType, ogImage, noindex = false }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Digitive Health` : defaults.title;
    const desc = description || defaults.description;
    const canonicalUrl = `${BASE_URL}${path}`;

    document.title = fullTitle;

    setMeta('description', desc);
    setMeta('robots', noindex ? 'noindex, nofollow' : 'index, follow');
    setLink('canonical', canonicalUrl);

    // Open Graph
    setMeta('og:title', fullTitle, 'property');
    setMeta('og:description', desc, 'property');
    setMeta('og:url', canonicalUrl, 'property');
    setMeta('og:type', ogType || defaults.ogType, 'property');
    setMeta('og:image', ogImage || defaults.ogImage, 'property');
    setMeta('og:site_name', 'Digitive Health', 'property');

    // Twitter
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', desc);
    setMeta('twitter:image', ogImage || defaults.ogImage);

    return () => {
      document.title = defaults.title;
      setMeta('description', defaults.description);
      setLink('canonical', BASE_URL + '/');
      setMeta('og:title', defaults.title, 'property');
      setMeta('og:description', defaults.description, 'property');
      setMeta('og:url', BASE_URL + '/', 'property');
    };
  }, [title, description, path, ogType, ogImage, noindex]);
}
